export const FETCH_PROMOTIONS = "FETCH_PROMOTIONS";
export const FETCH_PROMOTIONS_FAILED = "FETCH_PROMOTIONS_FAILED";
export const FETCH_PROMOTIONS_SUCCESS = "FETCH_PROMOTIONS_SUCCESS";
export const RESET_PROMOTIONS = "RESET_PROMOTIONS";
export const SHOW_MODAL_VIEW = "SHOW_MODAL_VIEW"
